var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,29H48V18.49C48,8.46,38.84,0,28,0,17,0,8,8.16,8,18.19V27h2V18.19C10,9.26,18.1,2,28,2S46,9.55,46,18.49V29H17V19.91c0-6.47,4.93-11.73,11-11.73s11,5.26,11,11.73V27h2V19.91c0-7.57-5.83-13.73-13-13.73S15,12.34,15,19.91V29H1a1,1,0,0,0-1,1V69a1,1,0,0,0,1,1H55a1,1,0,0,0,1-1V30A1,1,0,0,0,55,29ZM54,68H2V31H54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,65H40a1,1,0,0,1,0-2h6V40a1,1,0,0,1,2,0V64A1,1,0,0,1,47,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.76,36A8.08,8.08,0,0,0,20,43.28a8,8,0,0,0,4,7.63V60a1,1,0,0,0,1,1h7V59H26V50.14a.75.75,0,0,0-.46-.68,6,6,0,1,1,5,0,.82.82,0,0,0-.5.74V57h2V50.91A8,8,0,0,0,27.76,36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIco);
export default __webpack_public_path__ + "static/media/lock-ico.1ce98cc1ea95054869a3b24c43c28130.svg";
export { ForwardRef as ReactComponent };